module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav-item nav-item-buttons no-login-toggle",
    class: {
      'right-active': _vm.loginCssStatus
    }
  }, [_c('a', {
    staticClass: "button-default login-btn with-location",
    attrs: {
      "data-base-url": _vm.baceUrl + 'login.html',
      "href": "javascript:void(0);"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('a', {
    staticClass: "button-light register-btn1 with-location",
    attrs: {
      "data-base-url": _vm.baceUrl + 'register.html',
      "href": "javascript:void(0);"
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "logined display-none has-login-toggle",
    class: {
      'logined-active': _vm.loginCssStatus
    }
  }, [_c('div', {
    staticClass: "logined-show"
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "iconfont zhankai"
  }, [_vm._v("")]), _vm._v(" "), _c('ul', {
    staticClass: "logined-hide display-none"
  }, [_vm._l((_vm.loginArr), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.baceUrl + item.url
      }
    }, [_c('span', {
      staticClass: "iconfont",
      class: item.class,
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _c('i', [_vm._v(_vm._s(item.name))])])])
  }), _vm._v(" "), _c('li', {
    staticClass: "li-division"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    staticClass: "user",
    attrs: {
      "src": "/static/img/user.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://breadoffer.com/aboutus/qa.html"
    }
  }, [_c('span', {
    staticClass: "iconfont wenhao"
  }, [_vm._v("")]), _c('i', [_vm._v("帮助中心")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://member.breadoffer.com/logout"
    }
  }, [_c('span', {
    staticClass: "iconfont tuichudenglu"
  }, [_vm._v("")]), _c('i', [_vm._v("注销登录")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b749a7a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/login.vue
// module id = 211
// module chunks = 19